export function initHeaderGrowVisual() {
	const growWrapper = document.querySelector('.header-growing-visuals');
	if (!growWrapper) return;

	const hideBlock = growWrapper.querySelector('.hide-block');
	if (!hideBlock || hideBlock.offsetParent === null) return;

	const growElements = growWrapper.querySelectorAll('.growing-visual');

	growElements.forEach((growElement, index) => {
		const growElementId = growElement.id;
		const parentElement = growElement?.parentNode;
		const targetElement = growWrapper.querySelector('.growing-target[target-id="' + growElementId + '"]');
		const visualElement = growElement;

		// Exit if any required elements don't exist
		if (!parentElement || !targetElement || !visualElement) return;

		const offsetModifier = 150;
		const offsetValue = index * offsetModifier;

		gsap.fromTo(visualElement,
			{
				y: "0px",
			},
			{
				y: () => {
					const targetDocTop = targetElement.getBoundingClientRect().top + window.scrollY;
					const visualDocTop = visualElement.getBoundingClientRect().top + window.scrollY;
					return targetDocTop - visualDocTop;
				},
				ease: "none",
				scrollTrigger: {
					trigger: growWrapper,
					start: "top top",
					end: () => {
						const centeredEndPoint = (window.innerHeight * 0.5) + (visualElement.getBoundingClientRect().height * 0.4) - offsetModifier;
						return "top -" + ( centeredEndPoint + offsetValue ) + "px";
					},
					markers: false,
					scrub: true,
					invalidateOnRefresh: true,
				}
			},
		);

		gsap.fromTo(targetElement,
			{
				opacity: 0.25,
			},
			{
				opacity: 0,
				ease: "none",
				scrollTrigger: {
					trigger: growWrapper,
					start: "top top",
					end: "bottom bottom",
					markers: false,
					scrub: true,
					invalidateOnRefresh: true,
				}
			},
		);
	});
}

export function initGrowVisual() {
	const growElements = document.querySelectorAll('.flexible-grow-visual-content');
	if (!growElements) return;

	// Desktop grow elements.
	growElements.forEach(growElement => {
		const parentElement = growElement.querySelector('.growing-visual')?.parentNode;
		const targetElement = growElement.querySelector('.growing-target');
		const visualElement = growElement.querySelector(".growing-visual");

		// Exit if any required elements don't exist
		if (!parentElement || !targetElement || !visualElement) return;

		gsap.fromTo(visualElement,
			{
				width: () => targetElement.getBoundingClientRect().width + "px",
				height: () => targetElement.getBoundingClientRect().height + "px",
				y: () => {
					const height = targetElement.parentElement.parentElement.parentElement.getBoundingClientRect().height;
					const offset = targetElement.parentElement.parentElement.parentElement.getBoundingClientRect().top - targetElement.getBoundingClientRect().top;
					return -1 * ( 240 + ( height + offset ) ) + "px";
				},
				x: () => {
					const offset = -1 * (parentElement.getBoundingClientRect().left - targetElement.getBoundingClientRect().left);
					return offset + "px";
				},
			},
			{
				width: () => parentElement.getBoundingClientRect().width + "px",
				height: () => parentElement.getBoundingClientRect().height + "px",
				x: "0px",
				y: "0px",
				ease: "none",
				scrollTrigger: {
					trigger: growElement,
					start: () => {
						const offset = targetElement.parentElement.parentElement.parentElement.getBoundingClientRect().top - targetElement.getBoundingClientRect().top;
						return `top-=${offset} 60%`
					},
					end: "bottom-=" + (parentElement.parentNode.parentNode.getBoundingClientRect().height - (parentElement.getBoundingClientRect().height / 2) + 150) + " 60%",
					markers: false,
					scrub: true,
					invalidateOnRefresh: true,
				}
			},
		);
	});

	// Mobile grow elements.
	growElements.forEach(growElement => {
		const growingVisual = growElement.querySelector('.mobile-growing-visual');

		if ( ! growingVisual ) return;

		gsap.fromTo(growingVisual,
			// FROM state
			{
				y: "0px",
				paddingLeft: "20px",
				paddingRight: "20px",
			},
			// TO state
			{
				y: () => "200px",
				paddingLeft: "0px",
				paddingRight: "0px",
				ease: "none",
				scrollTrigger: {
					trigger: growElement,
					start: "top 25%",
					end: "+=" + (window.innerHeight * 0.5),
					markers: false,
					scrub: true,
					invalidateOnRefresh: true,
				}
			},
		);
	});
}
